/**
 * Landing Module - InfoModal Component
 */
import React, { useEffect } from 'react';
import { X } from 'lucide-react';
import { MODAL_CONTENT } from '../config/content';

export function InfoModal({ isOpen, onClose, modalId }) {
  const content = MODAL_CONTENT[modalId];
  
  useEffect(() => {
    document.body.style.overflow = isOpen ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [isOpen]);
  
  if (!isOpen || !content) return null;
  
  return (
    <div 
      className="fixed inset-0 z-50 flex items-center justify-center p-4 animate-fade-in" 
      onClick={onClose}
    >
      <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" />
      <div 
        className="relative w-full max-w-xl max-h-[80vh] bg-[var(--bg-surface)] rounded-2xl shadow-2xl overflow-hidden animate-modal-in" 
        onClick={e => e.stopPropagation()}
      >
        <div className="flex items-center justify-between p-5 border-b border-[var(--border-subtle)]">
          <h2 className="text-xl font-semibold text-[var(--text-main)]">{content.title}</h2>
          <button 
            onClick={onClose} 
            className="p-2 rounded-lg hover:bg-[var(--bg-highlight)] transition-colors"
            data-testid="modal-close-btn"
          >
            <X className="w-5 h-5 text-[var(--text-muted)]" />
          </button>
        </div>
        <div className="p-5 overflow-y-auto" style={{ maxHeight: 'calc(80vh - 70px)' }}>
          {content.content}
        </div>
      </div>
    </div>
  );
}
